export const base = 44;
export const small = 28;
export const medium = 44;
export const large = 56;

export const inputControl = 16;
